const ventas = {
  createVenta: 'venta',
  changePlan: 'venta/{{uuid_dventa}}/change-plan',
  readChangePlan: 'venta/{uuid_venta}/change-plan',
  readProductoPublico: 'venta/{{uuid_producto}}',
  readProductoGestionesPublico: 'venta/{{uuid_producto}}/gestiones',
  readSubscription: 'academia/suscripcion/{{uuid_academia}}',
  readVenta: 'academia/venta/{{uuid_venta}}',
  readVentaPagos: 'academia/venta/{{uuid_venta}}/pagos',
  readVentas: 'academia/ventas/{{uuid_academia}}',
  readVentasExportar: 'academia/ventas/{{uuid_academia}}/exportar',
  readVentasMisCobros: 'academia/ventas/cobros/{{uuid_academia}}',
  readVentasMisPagos: 'academia/{{uuid_academia}}/pagos',
  readSubscriptionNotificada: 'academia/ventas/suscripciones/{uuid_venta}',
  readVentasMisPagosExportar: 'academia/{{uuid_academia}}/pagos/exportar',
  updateVentaCuponDescuento: 'venta/activar-cupon-descuento',
  updateSubscription: 'academia/cancelar-suscripcion/{{uuid_suscripcion}}',
  updateCancelarVentaCancelada: 'academia/{{uuid_academia}}/venta/{{uuid_venta}}',
  updateVentasAnularPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/anular',
  updateVentasConfirmarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/confirmar',
  updateVentasReembolsarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/reembolsar'
}

export default ventas
